import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    assuredBy: 'Insured by {0}',
  },
  fr: {
    assuredBy: 'Assuré par {0}',
  },
} as const);

export default locales;
